import React from "react";
import { useTranslation } from "react-i18next";
import ClaimInfoTable from "./ClaimInfoTable";
import AppOutlineButton from "components/ui/AppOutlineButton";

const ClaimInfo = (props) => {
  let { sliderOrder } = props;
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex justify-start">
        <AppOutlineButton variant="secondary" size="lg" onClick={props.getsliderOrderStatus}>
          {t("Refresh for latest info")}
        </AppOutlineButton>
      </div>
      <ClaimInfoTable {...{ sliderOrder }} />
    </div>
  );
};

export default ClaimInfo;
